<template>
  <div class="d-flex flex-column">
    <div
      v-if="!templateId"
      class="d-flex flex-column align-center justify-center flex-grow-1"
    >
      <div class="text-body-2 text-textLight text-center">
        Select a template to see a preview
      </div>
    </div>

    <div
      v-else-if="loading"
      class="d-flex justify-center align-center flex-grow-1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="36"
        width="3"
      />
    </div>

    <v-sheet
      v-else
      class="overflow-y-auto d-flex flex-column ga-3 pr-1"
    >
      <div
        v-if="previewTitle"
        class="text-body-1 text-textDarkest font-weight-medium"
      >
        {{ previewTitle }}
      </div>

      <div class="fields-list">
        <div
          v-for="field in fields"
          :key="field.id"
        >
          <div class="d-flex justify-end mt-2 mb-1">
            <FieldLabel class="mb-1 ">
              {{ field.label }}
            </FieldLabel>
          </div>
          <DocumentPreviewFieldHtml :html="field.html" />
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { vueGetPreview } from '@/api/vue';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { joinFooterAndHeaderFields } from '@/helpers/headerFooterFields';
import DocumentPreviewFieldHtml from '@ui/components/general/DocumentPreviewFieldHtml/DocumentPreviewFieldHtml.vue';
import FieldLabel from '@/components/editor/field/FieldLabel.vue';

const props = defineProps({
  templateId: { type: Number, default: null },
});

const { addErrorSnackbar } = useAppSnackbar();

const loading = ref(false);
const fields = ref([]);
const previewTitle = ref(null);

const loadTemplate = async (id) => {
  if (!id) {
    fields.value = [];
    previewTitle.value = null;
    return;
  }

  try {
    loading.value = true;
    fields.value = [];
    previewTitle.value = null;

    const data = await vueGetPreview({ id });

    previewTitle.value = data.title || null;

    const rawFields = data.description_json?.fields || [];
    fields.value = joinFooterAndHeaderFields(rawFields)
      .filter((field) => field.html.length > 20);
  } catch (error) {
    addErrorSnackbar({ text: 'Error loading template preview.' });
    throw error;
  } finally {
    loading.value = false;
  }
};

watch(() => props.templateId, loadTemplate, { immediate: true });
</script>
